import { createSlice } from "@reduxjs/toolkit";
// import { AsyncStorage } from 'AsyncStorage';
// import { AsyncStorageKeys } from "../../utils/constants";

const compareListSlice = createSlice({
    name: 'comparesList',
    initialState: {
        comparesList: [],
    },
    reducers: {

        setCompareList: (state, action) => {

                state.comparesList= action.payload;
                // AsyncStorage.setItem(AsyncStorageKeys.CompareList, JSON.stringify(state.comparesList)).then(result => {
                //     console.log('ok')
                // }).catch(err => {
                //     console.log(err);
                // });
            
        },
        addItemToCompareList: (state, action) => {

if(state.comparesList.length > 0){
                state.comparesList= state.comparesList.unshift(action.payload);

            }else{
                state.comparesList=[action.payload];
            }
                // AsyncStorage.setItem(AsyncStorageKeys.CompareList, JSON.stringify(state.comparesList)).then(result => {
                //     console.log('ok')
                // }).catch(err => {
                //     console.log(err);
                // });
            
        },
        removeItemFromCompareList: (state, action) => {
            state.comparesList = state.comparesList.filter(item => item.id != action.payload);
            // AsyncStorage.setItem(AsyncStorageKeys.CompareList, JSON.stringify(state.comparesList)).then(result => {
            //     console.log('saved');
            // }).catch(err => {
            //     console.log(err)
            // });
        },
    }
});

export const { addItemToCompareList, removeItemFromCompareList,setCompareList }= compareListSlice.actions;
export default compareListSlice.reducer;